import React, { useState } from 'react';
import { Search, AlertCircle, CheckCircle } from 'lucide-react';
import { useFamilyStore } from '../stores/familyStore';

const CodeEntry: React.FC = () => {
  const [codigo, setCodigo] = useState('');
  const { buscarOSPorCodigo, isLoading, error, clearError } = useFamilyStore();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!codigo.trim()) {
      return;
    }

    // Limpar erro anterior
    clearError();
    
    // Buscar OS
    await buscarOSPorCodigo(codigo.trim());
  };

  const handleCodigoChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setCodigo(value);
    
    // Limpar erro quando o usuário digita
    if (error) {
      clearError();
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="mx-auto mb-4 flex justify-center">
            <img 
              src="/nexus_logo_complete.png" 
              alt="Nexus Funerária" 
              className="h-72 sm:h-96 w-auto object-contain"
            />
          </div>
          <p className="text-gray-600 text-lg">
            Portal da Família
          </p>
          <p className="text-sm text-gray-500 mt-2">
            Acompanhe o progresso em tempo real
          </p>
        </div>

        {/* Formulário de Código */}
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          <div className="text-center mb-6">
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Digite o Código de Acesso
            </h2>
            <p className="text-gray-600">
              Informe o código fornecido pela empresa para acompanhar o serviço
            </p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label htmlFor="codigo" className="block text-sm font-medium text-gray-700 mb-2">
                Código de Acesso
              </label>
              <div className="relative">
                <input
                  id="codigo"
                  type="text"
                  value={codigo}
                  onChange={handleCodigoChange}
                  placeholder="Ex: ABC123"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-center text-lg font-mono tracking-wider placeholder-gray-400 transition-colors"
                  disabled={isLoading}
                  autoComplete="off"
                  autoFocus
                />
                <div className="absolute inset-y-0 right-0 pr-3 flex items-center">
                  <Search className="h-5 w-5 text-gray-400" />
                </div>
              </div>
            </div>

            {/* Mensagem de Erro */}
            {error && (
              <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                <div className="flex items-center space-x-2">
                  <AlertCircle className="h-5 w-5 text-red-500" />
                  <span className="text-red-700 text-sm">{error}</span>
                </div>
              </div>
            )}

            {/* Botão de Busca */}
            <button
              type="submit"
              disabled={!codigo.trim() || isLoading}
              className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white py-3 px-4 rounded-lg font-medium hover:from-blue-700 hover:to-purple-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-lg hover:shadow-xl"
            >
              {isLoading ? (
                <div className="flex items-center justify-center space-x-2">
                  <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span>Buscando...</span>
                </div>
              ) : (
                <div className="flex items-center justify-center space-x-2">
                  <Search className="h-5 w-5" />
                  <span>Buscar Serviço</span>
                </div>
              )}
            </button>
          </form>

          {/* Informações Adicionais */}
          <div className="mt-6 text-center">
            <p className="text-xs text-gray-500">
              Este portal permite acompanhar o progresso do serviço funerário em tempo real
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-8">
          <p className="text-sm text-gray-500">
            © 2025 Nexus Funerária. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </div>
  );
};

export default CodeEntry;

